import { render } from "./PriceCell.vue?vue&type=template&id=58e97ce4"
import script from "./PriceCell.vue?vue&type=script&lang=js"
export * from "./PriceCell.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__